import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bProductCatalogProducts } from '@cart-services/hooks/fp-b2b/use-fp-b2b-product-catalog-products'
import { type CrossBrandMallHomeCampaign } from '@hooks-api/types/dataModel/cross-brand-mall'
import { useMemo } from 'react'
import { type ProductCardEntry } from '../types/product-card-entry'
import { getTopSellerProductCards } from '../utils/brand-top-seller-transformer'

export const TOP_SELLER_LIMIT = 6

interface UseBrandTopSellersProps {
  campaign: CrossBrandMallHomeCampaign
}

interface UseBrandTopSellersResult {
  productCardEntries: ProductCardEntry[]
  isProductsLoading: boolean
}

export const useBrandTopSellers = (props: UseBrandTopSellersProps): UseBrandTopSellersResult => {
  const { campaign } = props

  const { productCatalogDto, isValidating: isCatalogValidating, error: catalogError } = useFpB2bProductCatalogProducts(
    campaign.campaign_id,
    campaign.project_code,
    campaign.code,
    Platform.STM,
  )

  const productCardEntries = useMemo<ProductCardEntry[]>(() =>
    getTopSellerProductCards({
      topSellers: campaign.top_sellers,
      productCatalogDto,
      limit: TOP_SELLER_LIMIT,
    }),
  [campaign.top_sellers, productCatalogDto])

  return {
    productCardEntries,
    isProductsLoading: !catalogError && (isCatalogValidating || !productCatalogDto),
  }
}
